export enum SubscriptionStatus {
    Created = 'Created',
    WaitingOnPayment = 'WaitingOnPayment',
    Active = 'Active',
    WaitingOnRenewal = 'WaitingOnRenewal'
}